/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ChatLists = {
    type: 'array',
    contains: {
        type: 'ChatList',
    },
};